const getDefaultState = () => {
  return {
    isDataLoaded: false,
    dragLock: false,
    online: null,
    loading: false,
    fabVisible: true,
    mainMenuVisible: false,
    resourceSortMethod:
      localStorage.getItem('resourceSortMethod') || 'sequential'
  }
}

const state = getDefaultState()

const getters = {
  isDataLoaded: () => {
    return state.isDataLoaded
  },
  resourceSortMethod: (state) => state.resourceSortMethod
}

const actions = {
  updateOnlineStatus({ commit }) {
    navigator.onLine
      ? document.body.classList.remove('offLine')
      : document.body.classList.add('onLine')
    commit('setOnline', navigator.onLine)
  },
  toggleMainMenu({ commit, state }) {
    console.log('config/toggleMainMenu', state.mainMenuVisible)
    commit('setMainMenuVisible', !state.mainMenuVisible)
  },
  setDragLock({ commit }, dragLock) {
    commit('setDragLock', dragLock)
  },
  setFabVisible({ commit }, fabVisible) {
    commit('setFabVisible', fabVisible)
  },
  setDataLoaded({ commit }, isDataLoaded) {
    commit('setDataLoaded', isDataLoaded)
  },
  setLoading({ commit }, loading) {
    commit('setLoading', loading)
  },
  async resetState({ commit }) {
    await commit('resetState', null)
  },
  setResourceSortMethod({ commit }, method) {
    commit('SET_RESOURCE_SORT_METHOD', method)
  }
}

const mutations = {
  setOnline(state, online) {
    this._vm.$set(state, 'online', online)
  },
  setDragLock(state, dragLock) {
    this._vm.$set(state, 'dragLock', dragLock)
  },
  setFabVisible(state, fabVisible) {
    this._vm.$set(state, 'fabVisible', fabVisible)
  },
  setLoading(state, loading) {
    this._vm.$set(state, 'loading', loading)
  },
  setDataLoaded(state, isDataLoaded) {
    this._vm.$set(state, 'isDataLoaded', isDataLoaded)
  },
  setMainMenuVisible(state, mainMenuVisible) {
    this._vm.$set(state, 'mainMenuVisible', mainMenuVisible)
  },
  resetState(state) {
    const defaultState = getDefaultState()
    Object.keys(defaultState).forEach((key) => {
      state[key] = defaultState[key]
    })
  },
  SET_RESOURCE_SORT_METHOD(state, method) {
    state.resourceSortMethod = method
    localStorage.setItem('resourceSortMethod', method)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
